import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";

export const currentBranch = () => localStorage.getItem("pressops_branch") || "all";

export function BranchSelector({ onChange }) {
  const [d, setD] = useState(null);
  const [val, setVal] = useState(currentBranch());
  useEffect(() => {
    api.get("/tenant/branches").then((r) => {
      setD(r.data);
      const ids = r.data.branches.map((b) => b.id);
      if (r.data.restricted && val !== "all" && !ids.includes(val)) { localStorage.setItem("pressops_branch", "all"); setVal("all"); }
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d || d.branches.length < 1 && !d.restricted) return null;
  const change = (v) => { localStorage.setItem("pressops_branch", v); setVal(v); onChange(v); };
  return (
    <label className="flex items-center gap-2 text-sm text-slate-600" data-testid="branch-selector">
      <MapPin className="h-4 w-4 text-[#389F95]" />
      <select data-testid="branch-select" className="po-select h-8 w-56" value={val} onChange={(e) => change(e.target.value)}>
        <option value="all">{d.restricted ? "All my branches" : "All branches"}</option>
        {d.branches.filter((b) => b.status === "active").map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
    </label>
  );
}
